/**
 *
 * @module mediaPlayheadStatus
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef MediaPlayheadStatus
 * @type {Object}
 * @desc Provides the status of the playhead retrieval.
 *
 * @property {String} Success - A previous playhead position was found for the associated media and user.
 * @property {String} NoPlayhead - No playhead position was found for the associated media and user.
 * @property {String} Unavailable - Unable to retrieve the playhead position for the associated media and user.
 *
 */

/**
 *
 * @enum
 * @type {MediaPlayheadStatus}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    Success: null,
    /**
     *
     * @access public
     * @type {String}
     * @desc User has never played video before or cleared bookmarks.
     *
     */
    NoPlayhead: null,
    /**
     *
     * @access public
     * @type {String}
     * @desc There was an error retrieving the playhead position.
     *
     */
    Unavailable: null
});



// WEBPACK FOOTER //
// ./src/services/media/mediaPlayheadStatus.js